import strings from 'owa-strings/owa-mail-strings';
import { assertNever } from 'owa-assert';
export default function getViewFilterDisplay(filter) {
    switch (filter) {
        case 'All':
            return strings.allFilter;
        case 'Unread':
            return strings.unreadFilter;
        case 'Flagged':
            return strings.flaggedFilter;
        case 'ToOrCcMe':
            return strings.toMeFilter;
        case 'HasAttachment':
        case 'TaskActive':
        case 'TaskOverdue':
        case 'TaskCompleted':
        case 'DeprecatedSuggestions':
        case 'DeprecatedSuggestionsRespond':
        case 'DeprecatedSuggestionsDelete':
        case 'DeprecatedNoClutter':
        case 'DeprecatedClutter':
        case 'SystemCategory':
        case 'UserCategory':
        case 'Pinned':
        case 'Focused':
        case 'Locked':
        case 'Mentioned':
        case 'Hashtag':
            throw new Error('Filter not implemented');
        default:
            return assertNever(filter);
    }
}
//# sourceMappingURL=getViewFilterDisplay.js.map